import groq from 'groq';
import { TagsFragment } from './tags';
import { ImageComponentFragment } from './image';

export const CardContentFragment = groq`
  cardContent {
    includeInAutomatedCards,
    content {
      brands,
      headline,
      summary,
      publicationDate,
      ${TagsFragment},
      ${ImageComponentFragment}
    }
  }
`;

export const CardContentLiteFragment = groq`
  cardContent {
    content {
      ${ImageComponentFragment}
    }
  }
`;
